import React from "react";

import clsx from "clsx";

import { Box, Tooltip } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { MeasurementComponent, SubLocation } from "../../shared/enums/Result";
import { CableNaming } from "../../shared/enums/UTP2";
import {
  getSublocationLayoutByComponentType,
  getTranslatedSubLocationName,
} from "../../shared/helpers/SubLocationHelpers";

interface Props {
  selectedSublocation: SubLocation | undefined;
  selectedMeasurementComponent: MeasurementComponent | undefined;
  measurementComponent: MeasurementComponent;
  onChange?: (measurementComponent: MeasurementComponent, subLocation: SubLocation) => void;
  name?: string;
  icon: React.ReactNode;
  cableNaming?: CableNaming;
}

const useStyles = makeStyles((theme) => ({
  table: {
    display: "table",
    padding: "5px",
    width: "8em",
    height: "12em",
    borderCollapse: "collapse",
    borderStyle: "hidden",
    emptyCells: "show",
  },
  row: {
    display: "table-row",
  },
  cell: {
    display: "table-cell",
    border: "1px solid #dcdcdc",
    textAlign: "center",
    verticalAlign: "middle",
  },
  selectableCell: {
    "&:hover": {
      backgroundColor: "#E3F2FD",
      cursor: "pointer",
    },
  },
}));

const cellSizePx = 50;

export function SublocationSelector(props: Props) {
  const classes = useStyles();

  const measurementComponentLayout = getSublocationLayoutByComponentType(props.measurementComponent);

  function handleClick(subLocation: SubLocation) {
    props.onChange && props.onChange(props.measurementComponent, subLocation);
  }

  if (measurementComponentLayout) {
    const componentHeight = measurementComponentLayout.rows.length * cellSizePx;
    const componentWidth =
      measurementComponentLayout.rows.length > 0 && measurementComponentLayout.rows[0].columns?.length * cellSizePx;

    return (
      <div className={classes.table} style={{ width: `${componentWidth}px`, height: `${componentHeight}px` }}>
        {measurementComponentLayout?.rows.map((row, index) => {
          return (
            <div key={`${index}-cell`} className={classes.row}>
              {row.columns.map((sublocation) => {
                const tooltipTitle = getTranslatedSubLocationName(
                  sublocation,
                  props.measurementComponent,
                  props.cableNaming,
                );

                return (
                  <Tooltip key={`${sublocation}-tooltip`} title={tooltipTitle}>
                    <Box
                      key={`${sublocation}-cell`}
                      className={clsx(classes.cell, {
                        [classes.selectableCell]:
                          sublocation !== props.selectedSublocation ||
                          props.measurementComponent !== props.selectedMeasurementComponent,
                      })}
                      onClick={() => handleClick(sublocation)}
                      sx={{ width: cellSizePx, height: cellSizePx }}
                    >
                      <Box display="flex" justifyContent="center" alignItems="center" height="100%" width="100%">
                        {sublocation === props.selectedSublocation &&
                          props.measurementComponent === props.selectedMeasurementComponent &&
                          props.icon}
                      </Box>
                    </Box>
                  </Tooltip>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  } else return null;
}
